import {
  BaseWebComponentController,
  IListenerConfig,
  WebComponentEvent,
} from '../../../framework/BaseWebComponentController';
import { MobileSecurityCompanyGridWebComponent } from '../component/MobileSecurityCompanyGridWebComponent';
import { MobileSecurityCompanyGridRepository } from '../repository/MobileSecurityCompanyGridRepository';
import { MobileSecurityCompanyGridView } from '../view/MobileSecurityCompanyGridView';
import { template } from '../view/template';
import { AccountAction, MobileSecurityCompanyGridWebComponentSchema } from '../types';
import { showErrorToast } from '@nirvana/shared/common';
import { MobileSecurityActivationEmailsDialog } from '../../mobileSecurityActivationEmailsDialog/MobileSecurityActivationEmailsDialog';
import { MobileSecurityActivationEmailsDialogBodyWebComponent } from '../../mobileSecurityActivationEmailsDialog/mobileSecurityActivationEmailsDialogBody';
import { openConsoleForCurrentUserAndCompany } from '../../common/services';

export class MobileSecurityCompanyGridController extends BaseWebComponentController {
  public component: MobileSecurityCompanyGridWebComponent;
  public view!: MobileSecurityCompanyGridView;
  public viewConstructor: typeof MobileSecurityCompanyGridView;
  public dataRepository: MobileSecurityCompanyGridRepository;
  public dataRepositoryConstructor: typeof MobileSecurityCompanyGridRepository;

  constructor(component: MobileSecurityCompanyGridWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: MobileSecurityCompanyGridView,
      viewTemplate: template,
      dataRepositoryConstructor: MobileSecurityCompanyGridRepository,
    });
  }

  async getDataForView(): Promise<MobileSecurityCompanyGridWebComponentSchema> {
    return await this.dataRepository.getDataForView();
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$wrapper,
        event: AccountAction.CREATE,
        callback: e => this.view.showCreateAccountDialog(e.detail, () => this.createAccount(e.detail.id)),
      },
      {
        element: this.view.dom.$wrapper,
        event: AccountAction.CONSOLE,
        callback: this.openMobileSecurityConsole,
      },
      {
        element: this.view.dom.$wrapper,
        event: AccountAction.ACTIVATION,
        callback: e => this.showActivationLinksDialog(e.detail),
      },
    ];
  }

  private async createAccount(companyId: string) {
    try {
      const result = await this.dataRepository.createAccount(companyId);
      if (!result.success) {
        this.view.showCreateAccountErrorToast();
        return;
      }

      this.view.showCreateAccountSuccessToast();
      this.view.dom.$gridView.controller?.handleGridItemsLoad(true);
      this.view.dom.$customerView.controller?.refresh();
    } catch (e) {
      this.view.showCreateAccountErrorToast(e);
    }
  }

  private async openMobileSecurityConsole(event: WebComponentEvent) {
    const companyId = event.detail.id;

    this.view.toggleActionButtonsLoadingState(companyId, true);

    try {
      await openConsoleForCurrentUserAndCompany(companyId, this.dependencies);
    } catch (error) {
      showErrorToast(error);
    }

    this.view.toggleActionButtonsLoadingState(companyId, false);
  }

  private async showActivationLinksDialog(company: { id: string; name: string }) {
    const dialogBody = new MobileSecurityActivationEmailsDialogBodyWebComponent();
    const dialog = new MobileSecurityActivationEmailsDialog(dialogBody, company, this.dependencies);
    dialog.show();
  }
}
